import { render, staticRenderFns } from "./EGBRiskTab.vue?vue&type=template&id=54e42a80&"
import script from "./EGBRiskTab.vue?vue&type=script&lang=js&"
export * from "./EGBRiskTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports